import { parseFcmPushPayload } from './fcmPushPayload';
// ALERT_SOUND_DISABLED — import { playNotificationSound } from './notificationSound';

/** Tab title flash when a push arrives (foreground or background via SW). */
export const playPushAlertEffects = (payload) => {
  // ALERT_SOUND_DISABLED — in-tab chime (make this function async when re-enabling):
  // const played = await playNotificationSound();
  // if (process.env.NODE_ENV === 'development' && !played) {
  //   console.warn('[FCM] Alert sound skipped — click Enable or bell once to unlock audio');
  // }

  if (typeof document === 'undefined') {
    return;
  }

  const { title } = parseFcmPushPayload(payload);
  const original = document.title;
  document.title = `🔔 ${title}`;
  window.setTimeout(() => {
    if (document.title.startsWith('🔔 ')) {
      document.title = original;
    }
  }, 2500);
};
